<template>
  <div class="graph mt-5" v-if="this.game.points.length > 0">
    <b-form-select class="shadow-sm" v-model="selected" :options="gameList"></b-form-select>
    <point-table
      :points="sliceData.points" :gameInfo="game.gameInfo" :selected="selected"/>
    <div v-if="game.isProMode && game.hitsList" class="mt-3">
      <SelectHitsTable :points="sliceData.points"
        :labels="sliceData.labels" :hitsList="sliceData.hitsList"
        :gameInfo="game.gameInfo" :selected="selected" @edit="editHits"/>
    </div>
    <MatchFlow
      :points="sliceData.points" :gameInfo="game.gameInfo" :matchCnt="selected"/>
    <RallyTimesOnScore
      :points="sliceData.points" :labels="sliceData.labels"
      :gameInfo="game.gameInfo"/>
    <ScoreRateOnServeReceive :points="sliceData.points" :gameInfo="game.gameInfo"
      :selected="selected" />
    <ManualLabelsChartWrap
      :points="sliceData.points" :gameInfo="game.gameInfo"
      :manualLabels="sliceData.manualLabels" :matchCnt="selected"/>
    <div v-if="game.isProMode && game.hitsList">
      <HitOnScore
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <AssistOnScore
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <HitOnLoseScore
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <AssistOnLoseScore
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <HitAll
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <HitAllCourse
        :points="sliceData.points" :labels="sliceData.labels" :selected="selected"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <HitOnServe
        :points="sliceData.points" :labels="sliceData.labels" :selected="selected"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
    <div v-if="game.isProMode && game.hitsList">
      <HitOnServeCourse
        :points="sliceData.points" :labels="sliceData.labels"
        :gameInfo="game.gameInfo" :hitsList="sliceData.hitsList" />
    </div>
  </div>
</template>

<script>
import MatchFlow from '@/components/molecules/MatchFlow';
import PointTable from '@/components/molecules/PointTable';
import RallyTimesOnScore from '@/components/molecules/RallyTimesOnScore';
import ScoreRateOnServeReceive from '@/components/molecules/ScoreRateOnServeReceive';
import ManualLabelsChartWrap from '@/components/molecules/ManualLabelsChartWrap';
import SelectHitsTable from '@/components/molecules/SelectHitsTable';
import HitOnScore from '@/components/molecules/HitOnScore';
import HitAll from '@/components/molecules/HitAll';
import HitOnServe from '@/components/molecules/HitOnServe';
import HitOnServeCourse from '@/components/molecules/HitOnServeCourse';
import HitAllCourse from '@/components/molecules/HitAllCourse';
import AssistOnScore from '@/components/molecules/AssistOnScore';
import AssistOnLoseScore from '@/components/molecules/AssistOnLoseScore';
import HitOnLoseScore from '@/components/molecules/HitOnLoseScore';
import func from '@/lib/func';

export default {
  name: 'graph',
  props: ['game'],
  components: {
    MatchFlow,
    PointTable,
    RallyTimesOnScore,
    ScoreRateOnServeReceive,
    ManualLabelsChartWrap,
    SelectHitsTable,
    HitOnScore,
    HitAll,
    HitOnServe,
    HitOnServeCourse,
    HitAllCourse,
    AssistOnScore,
    AssistOnLoseScore,
    HitOnLoseScore,
  },
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    gameList() {
      const options = [];
      options.push({ value: 0, text: '全体' });
      for (let i = 1; i <= this.sliceData.maxGameCnt; i++) {
        options.push({ value: i, text: `${i}ゲーム目` });
      }
      return options;
    },
    sliceData() {
      // 選択されたゲームごとにstoreのpoints,labelsを選択して返却
      return func.sliceData(this.selected, this.game);
    },
  },
  methods: {
    editHits(pointIdx, hitIdx) {
      this.$emit('edit', pointIdx, hitIdx);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.graph{
  text-align:left;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/Graph.vue